
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 62.187 55.377"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M1.854 53.499H32.15v-1.18c0-3.422.002-8.94-.006-10.921-.012-3.606-3.223-6.06-7.989-6.107-4.708-.049-9.48-.049-14.187 0-4.817.051-8.07 2.496-8.09 6.078-.012 1.553-.015 5.26-.017 8.44l-.006 3.69zM34 55.377H0l.01-5.57c.001-3.186.005-6.896.016-8.449.028-4.615 4.108-7.882 9.923-7.944 4.72-.05 9.505-.05 14.226 0 5.855.058 9.802 3.263 9.82 7.976C34 43.373 34 48.895 34 52.318zM17 11.303c-5.004 0-9.073 4.071-9.073 9.074s4.07 9.074 9.073 9.074c5.004 0 9.073-4.071 9.073-9.074s-4.07-9.074-9.073-9.074m0 20.074c-6.066 0-11-4.936-11-11s4.934-11 11-11 11 4.936 11 11-4.934 11-11 11M39.008 1.933c-2.886 0-5.235 2.34-5.235 5.215v12.443c0 2.874 2.349 5.214 5.235 5.214H55.01c2.887 0 5.236-2.34 5.236-5.214V7.147c0-2.875-2.349-5.215-5.236-5.215h-16zM55.01 26.738h-16c-3.959 0-7.177-3.205-7.177-7.147V7.147C31.832 3.206 35.05 0 39.008 0H55.01c3.957 0 7.177 3.206 7.177 7.148v12.443c0 3.942-3.22 7.147-7.177 7.147z"}})])
          )
        }
      }
    